module.exports = __webpack_public_path__ + "static/logo-cardtronics-new-b52e2f70c394cc4b9ba0532f5b5fe89f.png";